import { http_api } from "../../leadg-api";
const GetPayAndCheckByContractId = (contractId) => {
    return http_api.get(`company/get-check-and-pay-information-by-contract-id/${contractId}`);
};
const PayAndCheckInfo = {
    GetPayAndCheckByContractId
};
export default PayAndCheckInfo;
